export default __webpack_public_path__ + "static/media/Manuable-Imagotipo-Horizontal-Tagline.7646c1f5.png";